export default "/images/arrow-left.svg?5f34409c4cb0180c48082d493129a21f";